module.exports = __webpack_public_path__ + "img/Tower.e8c10c5e.png";